/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Collapse element for service user auth
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { icons } from '../../../assets';
import { Collapse, CollapsePanel } from '../../../components/common';
import { makeSelectTranslationPageAuthServiceAccess } from '../../../modules/internationalization/intSelectors';
import { IPageAuthServiceAccessTranslation } from '../../../modules/internationalization/types';
import { IRootReducer } from '../../../reducers/rootReducer';
import {
    AuthCollapseBodyStyle,
    AuthCollapsePanelContainerStyle,
    AuthCollapseTitleStyle,
    AuthCollapseWrapper,
} from '../../PageAuth/components/AuthCollapse/styled/AuthCollapseStyled';




const AuthServiceAccessCollapse = (props: IConnectedProps) => {
    return (
        <AuthCollapseWrapper>
            <Collapse
                bodyStyle={AuthCollapseBodyStyle}
                icon={icons.arrowListDownMedium}
                panelContainerStyle={AuthCollapsePanelContainerStyle}
                titleStyle={AuthCollapseTitleStyle}
            >
                <CollapsePanel titleValue={props.translation.collapse.title}>
                    <div dangerouslySetInnerHTML={{ __html: props.translation.collapse.body }}/>
                </CollapsePanel>
            </Collapse>
        </AuthCollapseWrapper>
    );
};

interface IConnectedProps {
    translation: IPageAuthServiceAccessTranslation;
}

export const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    translation: makeSelectTranslationPageAuthServiceAccess(),
});

export default connect(mapStateToProps)(AuthServiceAccessCollapse);
